import classNames from 'classnames';
import { Component } from 'react';

import ItemNoEdit from 'common/components/item/ItemNoEdit';
import { getCurrency } from 'common/helpers/miscHelper';
import { currencyFormat } from 'common/helpers/numberHelper';

import BottleDeposit from './summary/BottleDeposit';
import Duties from './summary/Duties';
import DutyUnpaidEstimate from './summary/DutyUnpaidEstimate';
import PrimeSavings from './summary/PrimeSavings';
import Shipping from './summary/Shipping';
import Taxes from './summary/Taxes';
import TaxesIncludedInPrice from './summary/TaxesIncludedInPrice';

class OrderSummaryReceipt extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOrderSummary: false
    };
  }

  handleToggleOrderSummary = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({
      showOrderSummary: !prevState.showOrderSummary
    }));
  };

  render() {
    const { order, settings } = this.props;
    const { showOrderSummary } = this.state;
    return (
      <>
        <div className="c7-checkout-template__toggle">
          <div>
            <a onClick={this.handleToggleOrderSummary}>
              <span>Order No. {order.orderNumber}</span>
              <span>{currencyFormat(order.total, settings)}</span>
            </a>
          </div>
        </div>

        <section
          className={classNames(
            'c7-checkout-summary',
            showOrderSummary && 'c7-visible'
          )}
        >
          <div className="c7-cart-items c7-cart-items--order-history">
            {order.items.map((item) => (
              <ItemNoEdit key={item.id} item={item} settings={settings} />
            ))}
          </div>
          <div className="c7-cart-summary">
            <div className="c7-cart-summary__subtotal">
              <div>Subtotal:</div>
              <div>{currencyFormat(order.subTotal, settings)}</div>
            </div>

            <Shipping shipping={order.shipping} settings={settings} />
            <Taxes taxes={order.taxes} settings={settings} />
            <Duties duties={order.duties} settings={settings} />
            <BottleDeposit order={order} settings={settings} />

            <div className="c7-cart-summary__total">
              <div>Total:</div>
              <div>
                <span>{getCurrency(settings)}</span>{' '}
                {currencyFormat(order.total, settings)}
              </div>
            </div>
            {order.tipTotal > 0 && (
              <>
                <div>
                  <div>Tip</div>
                  <div>{currencyFormat(order.tipTotal, settings)}</div>
                </div>

                <div className="c7-cart-summary__total">
                  <div>Total after Tip:</div>
                  <div>
                    <span>{getCurrency(settings)}</span>{' '}
                    {currencyFormat(order.totalAfterTip, settings)}
                  </div>
                </div>
              </>
            )}

            <TaxesIncludedInPrice taxes={order.taxes} settings={settings} />
            <DutyUnpaidEstimate duties={order.duties} settings={settings} />
            <PrimeSavings order={order} settings={settings} />
          </div>
        </section>
      </>
    );
  }
}

export default OrderSummaryReceipt;
